import http from "@/api/http";

export default {
    search (req) {
        return http.get(`flights/${req.dayOfOrigin}`)
    },
    flightLatestLdm (id) {
        return http.get(`flights/${id}/ldm`)
    },
    flightConnections (id) {
        return http.get(`flights/${id}/connections`)
    }
}
